import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SupportButton } from './SupportButton';

interface RegistrationHelpSectionProps {
  sx?: object;
}

export const RegistrationHelpSection: React.FC<RegistrationHelpSectionProps> = ({ sx }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box 
      sx={{ 
        mt: 2, 
        mb: 3,
        p: 2, 
        bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'grey.50', 
        borderRadius: 1,
        border: `1px solid ${theme.palette.mode === 'dark' ? 'grey.800' : 'grey.200'}`,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          bgcolor: theme.palette.mode === 'dark' ? 'primary.dark' : 'primary.light',
          borderRadius: '3px 3px 0 0',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          bgcolor: theme.palette.mode === 'dark' ? 'primary.dark' : 'primary.light',
          borderRadius: '0 0 1px 1px',
        },
        ...sx 
      }}
    >
      <Typography variant="body2" gutterBottom fontWeight={600} color="text.primary">
        {t('support.registrationProblems')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.5 }}>
        {t('support.registrationHelp')}
      </Typography>
      <SupportButton variant="link" />
    </Box>
  );
};
